import React from 'react';
import styles from './styles.module.scss';

function Copyright() {
  return (
    <span className={styles.copyrightText}>
      <nbx-text>©{new Date().getFullYear()} Norwegian Block Exchange</nbx-text>
    </span>
  );
}

export default Copyright;
